import { render } from "./AddGlobalPriceModal.vue?vue&type=template&id=1c35bbd8&ts=true"
import script from "./AddGlobalPriceModal.vue?vue&type=script&lang=ts"
export * from "./AddGlobalPriceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__